import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { getPropsFromMeta } from "../../utils"
import CompMeta from '../../meta/LowCodeComponents/TreeTable';

/**
 * @class NCTreeTable
 * @column 1
 * @compType 1
 * @canAppend false
 * @path LowCodeComponents.NCTreeTable
 * @label 树状表格
 *
 */
class NCTreeTable extends Component {
    constructor(props) {
        super(props);
    }
    static propTypes = {
        /**
         * @title 区域编码
         * @description 区域编码
         */
        moduleId: PropTypes.string.isRequired,
        /**
         * @title 是否异步
         * @description 是否异步
         */
        async: PropTypes.bool,
        /**
         * @title 是否需要复选框
         * @description 是否需要复选框
         */
        showCheckBox: PropTypes.bool,
        /**
         * @title 是否可拖拽
         * @description 是否可拖拽
         */
        isDrag: PropTypes.bool,
        /**
         * @title 是否显示查询按钮
         * @description 是否显示查询按钮
         */
        isLazyload: PropTypes.bool,
        /**
         * @title 是否自适应高度
         * @description 是否自适应高度
         */
        adaptionHeight: PropTypes.bool,
        /**
         * @title 其他区域高度
         * @description 其他区域高度
         */
        otherAreaHeight: PropTypes.number,
        /**
         * @title 是否显示多行
         * @description 是否显示多行
         */
        multipleRowCell: PropTypes.bool,
        /**
         * @title 是否增加空白列
         * @description 是否增加空白列
         */
        addBlankCol: PropTypes.bool,
        /**
         * @title 多行展示是否显示全部内容
         * @description 多行展示是否显示全部内容
         */
        bodyExpandAllInRow: PropTypes.bool,
        /**
         * @title 是否在弹窗内
         * @description 是否在弹窗内
         */
        inModal: PropTypes.bool,
        /**
         * @title 行点击是否勾选
         * @description 行点击是否勾选
         */
        disableRowClickSelect: PropTypes.bool,
        /**
         * @title 隐藏右键菜单全部展开
         * @description 隐藏右键菜单全部展开
         */
        hideExpandAll: PropTypes.bool,
        /**
         * @title 隐藏右键菜单包含下级
         * @description 隐藏右键菜单包含下级
         */
        hideIncludeChild: PropTypes.bool,
         /**
         * @title 是否可见
         * @description 是否可见
         */
          visible: PropTypes.bool,
    }
    static defaultProps = {
        async: false,
        showCheckBox: false,
        isDrag: true,
        adaptionHeight: true,
        checkOnRowClick: true,
        multipleRowCell: false,
        isLazyload:true,
        addBlankCol:true,
        inModal:false
    }
    static getCompMeta() {
        return CompMeta;
    }

    renderComp() {
        const { treeTableManyCol , moduleId, meta, config = {} } = this.props;
        const { treeTableCol  } = treeTableManyCol;
        const configProps = getPropsFromMeta(this.props, NCTreeTable.getCompMeta());
        let metaData = meta.getMeta();
        let ret = null;
        let treeMetaData = metaData[moduleId];
        if (treeMetaData) {
            ret = (
                <React.Fragment>
                    {treeTableCol(moduleId, Object.assign(configProps, config))}
                </React.Fragment>
            )
        } else {
            ret = (
                <div>没有绑定模板数据</div>
            )
        }
        return ret;
    }

    render() {
        return (
            <React.Fragment>
                {this.renderComp()}
            </React.Fragment>
        )
    }
}

export default NCTreeTable;
